/**
 * 热门交易栏方向
 */
export enum HotTradeBarDirectionEnum {
    UP = 0,
    DOWN = 1
}
